<!--====================================
=            WIDGETS CHARTS            =
=====================================-->

<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Widgets Charts</div>
      </base-header>
    </v-row>
    <v-row>
      <v-col class="col-12 col-md-3 col-sm-12">
        <v-card class=" rounded-lg" color="primary lighten-2">
          <v-card-text>
            <v-sheet color="rgba(0, 0, 0, .12)" elevation="5" outlined class="rounded-lg">
              <v-sparkline :value="value" color="white" elevation="10" height="100" padding="24" stroke-linecap="round"
                           smooth>
                <template v-slot:label="item">
                  ${{ item.value }}
                </template>
              </v-sparkline>
            </v-sheet>
          </v-card-text>

          <v-card-text>
            <div class="text-h4 font-weight-black white--text mb-2">
              56%
            </div>
            <div class="subtitle-1 font-weight-black white--text">
              Sales Last 24h
            </div>
          </v-card-text>

          <v-divider></v-divider>

          </v-card-actions>
        </v-card>

      </v-col>
      <v-col class="col-12 col-md-3 col-sm-12">
        <v-card class=" rounded-lg" color="secondary">
          <v-card-text>
            <v-sheet color="rgba(0, 0, 0, .12)" elevation="5" outlined class="rounded-lg">
              <v-sparkline :value="value" color="white" elevation="10" height="100" padding="24" stroke-linecap="round"
                           smooth>
                <template v-slot:label="item">
                  ${{ item.value }}
                </template>
              </v-sparkline>
            </v-sheet>
          </v-card-text>

          <v-card-text>
            <div class="text-h4 font-weight-black white--text mb-2">
              77%
            </div>
            <div class="subtitle-1 font-weight-black white--text">
              Profit Year
            </div>
          </v-card-text>

          <v-divider></v-divider>

          </v-card-actions>
        </v-card>

      </v-col>
      <v-col class="col-12 col-md-3 col-sm-12">
        <v-card class=" rounded-lg" color="accent lighten-2">
          <v-card-text>
            <v-sheet color="rgba(0, 0, 0, .12)" elevation="5" outlined class="rounded-lg">
              <v-sparkline :value="value" color="white" elevation="10" height="100" padding="24" stroke-linecap="round"
                           smooth>
                <template v-slot:label="item">
                  ${{ item.value }}
                </template>
              </v-sparkline>
            </v-sheet>
          </v-card-text>

          <v-card-text>
            <div class="text-h4 font-weight-black white--text mb-2">
              25%
            </div>
            <div class="subtitle-1 font-weight-black white--text">
              Loss Last 24h
            </div>
          </v-card-text>

          <v-divider></v-divider>

          </v-card-actions>
        </v-card>

      </v-col>
      <v-col class="col-12 col-md-3 col-sm-12">
        <v-card class=" rounded-lg" color="success ">
          <v-card-text>
            <v-sheet color="rgba(0, 0, 0, .12)" elevation="5" outlined class="rounded-lg">
              <v-sparkline :value="value" color="white" elevation="10" height="100" padding="24" stroke-linecap="round"
                           smooth>
                <template v-slot:label="item">
                  ${{ item.value }}
                </template>
              </v-sparkline>
            </v-sheet>
          </v-card-text>

          <v-card-text>
            <div class="text-h4 font-weight-black white--text mb-2">
              86%
            </div>
            <div class="subtitle-1 font-weight-black white--text">
              Verson Last 24h
            </div>
          </v-card-text>

          <v-divider></v-divider>

          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <template>
       
        <v-col cols="12" md="4" sm="12">
          <base-card>
            <div slot="card-header">

              Echarts Pie Widgeths
            </div>
            <div slot="card-body">
             <echarts-pie></echarts-pie>
            </div>
          </base-card>
          <base-card class="mt-5">
            <div slot="card-header">
                Echarts Area
            </div>
            <div slot="card-body">
             <echarts-area></echarts-area>
            </div>
          </base-card>
        </v-col>
        <v-col cols="12" md="4" sm="12">
          <card-sparkline></card-sparkline>
        </v-col>
        <v-col cols="12" md="4" sm="12">
          <card-list-spark></card-list-spark>
        </v-col>

      </template>
    </v-row>

  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
  import CardSparkline from '../../components/Cards/CardSparkline'
  import CardListSpark from '../../components/Cards/CardListSpark'
  import EchartsPie from '../../components/Charts/EchartsPie'
  import EchartsArea from '../../components/Charts/EchartsArea'
  export default {
    components: {
      BaseCard,
      BaseHeader,
      CardSparkline,
      CardListSpark,EchartsPie,EchartsArea
    },
    data: () => ({
      fill: true,
      cycle: false,
      value: [
        423,
        446,
        675,
        510,
        590,
        610,
        760,
      ],
      value: 'recent',
      recent: [{
          active: true,
          color: 'purple',
          avatar: 'home',
          title: 'Jump ',
        },
        {
          active: true,
          avatar: 'email',
          color: 'blue',
          title: 'Pray'
        },
        {
          avatar: 'face',
          color: 'green',
          title: 'Love',
        },
        {
          color: 'pink',
          avatar: 'tag',
          title: 'Organized',
        }, {
          color: 'red',
          avatar: 'home',
          title: 'HAppy',
        }, {
          color: 'amber',
          avatar: 'home',
          title: 'Life HAppy',
        },
      ],
      labels: [
        '12am',
        '3am',
        '6am',
        '9am',
        '12pm',
        '3pm',
        '6pm',
        '9pm',
      ],
      value: [
        200,
        675,
        410,
        390,
        310,
        460,
        250,
        240,
      ],
    }),


  }
</script>

<!--====  End of WIDGETS CHARTS  ====-->
